<template>
  <v-container>
    <avs-backButton />
    <v-row class="justify-center align-center">
      <v-col
        cols="12"
        md="7"
      >
        <MediaSettings
          :localTracks="localTracks"
          @update-tracks="updateTracks"
        />
      </v-col>
      <v-col
        cols="12"
        md="5"
        class="justify-start"
      >
        <v-row class="justify-start">
          <v-col cols="12">
            <div v-if="inspection">
              <div class="text-center">
                <v-icon
                  color="primary"
                  size="40"
                  >mdi-magnify-scan</v-icon
                >

                <div class="text-h5 mb-6 mt-6 primary--text">
                  {{ $tc("categories.inspection.name", 1) }} : {{ inspection.name }}
                </div>
              </div>
              <v-row
                class="justify-left"
                v-if="is_authenticated"
              >
                <v-col cols="12">
                  <v-row class="mt-0 d-flex">
                    <v-col
                      cols="4"
                      class="body-1 font-weight-bold"
                    >
                      {{ $t("commons.inspector") }}
                    </v-col>
                    <v-col class="pb-0 mb-0 text-truncate">
                      {{ inspector }}
                    </v-col> </v-row
                  ><v-row class="mt-0 d-flex">
                    <v-col
                      cols="4"
                      class="body-1 font-weight-bold"
                    >
                      {{ $t("commons.date.start_date_time") }}
                    </v-col>
                    <v-col class="pb-0 mb-0">
                      {{ toDatetime(inspection.start_date) }}
                    </v-col>
                  </v-row>
                  <v-row class="mt-0 d-flex">
                    <v-col
                      cols="4"
                      class="body-1 font-weight-bold"
                    >
                      {{ $t("commons.date.estimate_duration") }}
                    </v-col>
                    <v-col class="pb-0 mb-0">
                      {{ estimatedDuration }}
                    </v-col>
                  </v-row>
                  <v-row class="mt-0 d-flex">
                    <v-col
                      cols="4"
                      class="body-1 font-weight-bold"
                    >
                      {{ $t("commons.status.name") }}
                    </v-col>
                    <v-col class="pb-0 mb-0">
                      {{ inspection.status }}
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </div>
            <div v-if="inspection && !is_authenticated">
              {{ $t("messages.information.your_name") }}
              <v-text-field
                filled
                v-model="guestUsername"
                label="Your name*"
                required
              ></v-text-field>
            </div>
            <div class="text-center mt-4">
              <div class="text-h5 font-weight-light mb-8">
                {{
                  hasEnded
                    ? $t("categories.inspection.has_ended")
                    : !hasStarted
                    ? $t("categories.inspection.has_not_started")
                    : $t("categories.inspection.ready_to_participate")
                }}
              </div>

              <v-btn
                color="blue white--text"
                @click="participate()"
                large
                rounded
                :disabled="!hasStarted || hasEnded || (!is_authenticated && guestUsername === '')"
              >
                <v-icon left>mdi-login</v-icon>
                {{ $t("actions.participate") }}
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import MediaSettings from "./utils/MediaSettings.vue"
import { getDuration, isDateBefore, toDatetime } from "@/utils/datetime"

export default {
  name: "MettingReception",
  components: {
    MediaSettings
  },
  props: {
    inspection: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      guestUsername: "",
      loading: true,
      authentifiedUser: true,
      localTracks: []
    }
  },
  created() {
    this.$parent.$on("leave-inspection", this.leaveMediaSettings)
  },
  beforeDestroy() {
    this.leaveMediaSettings()
  },
  methods: {
    toDatetime,
    leaveMediaSettings() {
      if (this.localTracks) {
        this.localTracks.forEach(track => {
          track.stop()
        })
      }
    },
    updateTracks(tracks) {
      this.localTracks = tracks
      this.$emit("update-local-track", this.localTracks)
    },
    participate() {
      this.$emit("update-username", this.guestUsername)
      this.$emit("join")
    }
  },
  computed: {
    is_authenticated() {
      return this.$store.getters["app/isSignedIn"]
    },
    hasStarted() {
      if (!this.inspection) return true
      return isDateBefore(this.inspection.start_date)
    },
    hasEnded() {
      if (!this.inspection) return true
      return isDateBefore(this.inspection.end_date)
    },
    estimatedDuration() {
      if (!this.inspection) return ""
      return getDuration(this.inspection.start_date, this.inspection.end_date)
    },
    inspector() {
      if (this.inspection) return this.inspection.created_by
      return ""
    }
  }
}
</script>
